import { FlowNodeBase } from './FlowNodeBase';
import { FlowNodeResourceChips } from './FlowNodeResourceChips';

interface FlowAgentTaskNodeData {
  label: string;
  status: string;
  config: {
    responseFormat?: string;
    outputKey?: string;
    personaId?: string;
    agentType?: string;
    model?: string;
    providerSecretId?: string;
  };
}

export function FlowAgentTaskNode({
  data,
  selected,
}: {
  data: FlowAgentTaskNodeData;
  selected?: boolean;
}) {
  return (
    <FlowNodeBase
      nodeType="agent_task"
      label={data.label}
      selected={selected}
      isActive={data.status === 'running'}
      status={data.status}
      footer={
        <>
          {data.config.responseFormat === 'json' ? 'JSON task' : 'Text task'}
          {data.config.outputKey ? ` → ${data.config.outputKey}` : ''}
        </>
      }
    >
      <FlowNodeResourceChips
        personaId={data.config.personaId}
        agentType={data.config.agentType}
        model={data.config.model}
        providerSecretId={data.config.providerSecretId}
        slots={{ agentType: true, model: true, providerKey: true }}
      />
    </FlowNodeBase>
  );
}
